module.exports = __webpack_public_path__ + "media/components/users/integrations/images/calendar_integration-ada3781ebadceb9b7c3c7a484dd2d387.svg";